import React, { useContext } from "react";
import SelectBox from "components/FormElements/SelectBox";
import Label from "components/FormElements/Label";
import { AssignmentContext } from "context/Assignment";

export default function TypeField(props) {
    const { loading, preformingStateChange, isUserEditable } =
        useContext(AssignmentContext);

    if (loading) {
        return (
            <div>
                <Label>Type</Label>
                <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
            </div>
        );
    }

    return (
        <SelectBox
            label="Type"
            name="type"
            id="type"
            disabled={loading || preformingStateChange || !isUserEditable}
            options={["article", "photo"]}
        />
    );
}
